/**
 * Stripe dashboard uses stable, prefix-based routing. Unknown prefixes fall
 * back to the search endpoint (the `?query=` form — `/search/{id}` is not a
 * real route).
 */
export const stripeDashboardUrl = (id: string): string => {
  if (id.startsWith('in_')) return `https://dashboard.stripe.com/invoices/${id}`
  if (id.startsWith('cus_')) return `https://dashboard.stripe.com/customers/${id}`
  if (id.startsWith('sub_')) return `https://dashboard.stripe.com/subscriptions/${id}`
  if (id.startsWith('ch_') || id.startsWith('pi_')) return `https://dashboard.stripe.com/payments/${id}`
  return `https://dashboard.stripe.com/search?query=${encodeURIComponent(id)}`
}
